export const templateComps = {
  confirmModal: {
    cancel: "Abbrechen",
    delete: "Löschen",
  },
  channexIncident: {
    kicker: "Wichtiger Hinweis",
    brandTitle: "Externe Störung",
    closeLabel: "Hinweis schließen",
    subtitle:
      "Wir beobachten die Lage und prüfen die Synchronisierung, sobald der Dienst wiederhergestellt ist.",
    title:
      "Allgemeine Störung bei der Verbindung mit Booking / Airbnb / externem channel manager",
    lead: "Hallo, wir stellen eine allgemeine Störung bei unserem externen Anbieter für die OTA-Synchronisierung fest.",
    text: "Diese Störung betrifft dessen API und kann die Synchronisierung von Buchungen, Verfügbarkeiten und Datumssperren verzögern.",
    note: "Sobald die Verbindung wieder steht, prüfen wir die Datensynchronisierung, um Buchungen, Verfügbarkeiten und Datumssperren zu überprüfen.",
    textLast:
      "Bei WA Checkin prüfen wir die Synchronisierung, sobald der Dienst wieder funktioniert.",
    button: "Verstanden",
  },
  notificationsNav: {
    title: "Benachrichtigungen",
    recent: "aktuell",
    emptyTitle: "Keine Benachrichtigungen",
    emptyText:
      "Wenn bei Ihren Buchungen etwas Wichtiges passiert, erscheint es hier.",
    seeAll: "Alle Benachrichtigungen ansehen",
    meta: {
      t1: { status: "Neu", category: "Buchung" },
      t2: { status: "Aktualisiert", category: "Buchung" },
      t3: { status: "Storniert", category: "Buchung" },
      t4: { status: "Abgeschlossen", category: "Check-in" },
      t5: { status: "Angefragt", category: "Service" },
      t6: { status: "Erhalten", category: "Anfrage" },
      t7: { status: "Genehmigt", category: "Anfrage" },
      t8: { status: "Abgelehnt", category: "Anfrage" },
      t9: { status: "Bestätigt", category: "Zahlung" },
      t10: { status: "Zahlung ausstehend", category: "offene Zahlung" },
      t11: { status: "Zimmer zuweisen", category: "Buchung" },
      t12: { status: "Zustellung fehlgeschlagen", category: "Check-in" },
      t13: { status: "Nicht gesendet", category: "Gästemeldung" },
      t15: { status: "Aktiv", category: "Abonnement" },
      default: { status: "Hinweis", category: "System" },
    },
    typeLabel: {
      t1: "NEUE BUCHUNG",
      t2: "BUCHUNG AKTUALISIERT",
      t3: "BUCHUNG STORNIERT",
      t4: "CHECK-IN",
      t5: "SERVICE",
      t6: "ANFRAGE",
      t7: "ANFRAGE GENEHMIGT",
      t8: "ANFRAGE ABGELEHNT",
      t10: "ZAHLUNG AUSSTEHEND",
      t11: "ZIMMER ZUWEISEN",
      t12: "ZUSTELLUNG FEHLGESCHLAGEN",
      t13: "GÄSTEMELDUNG",
      t15: "ABONNEMENT AKTIV",
      default: "BENACHRICHTIGUNG",
    },
  },
};
